import { ReactNode } from 'react';
import { cn } from '../../utils/utils';

export interface EmptyStateProps {
  icon: React.ComponentType<{ className?: string }>;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

const sizeConfig = {
  sm: {
    container: 'py-8',
    icon: 'w-6 h-6',
    iconWrapper: 'w-14 h-14 mb-3',
    title: 'text-base',
    description: 'text-sm',
  },
  md: {
    container: 'py-12',
    icon: 'w-8 h-8',
    iconWrapper: 'w-16 h-16 mb-4',
    title: 'text-lg',
    description: 'text-sm',
  },
  lg: {
    container: 'py-16',
    icon: 'w-10 h-10',
    iconWrapper: 'w-20 h-20 mb-6',
    title: 'text-xl',
    description: 'text-base',
  },
};

export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  className,
  size = 'md',
}: EmptyStateProps) {
  const config = sizeConfig[size];

  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center text-center',
        config.container,
        className
      )}
    >
      <div
        className={cn(
          'mx-auto flex items-center justify-center rounded-full',
          'bg-muted',
          config.iconWrapper
        )}
      >
        <Icon
          className={cn(config.icon, 'text-muted-foreground dark:text-primary')}
        />
      </div>

      <h3 className={cn('mb-2 font-medium', config.title, 'text-foreground')}>
        {title}
      </h3>

      {description && (
        <p
          className={cn(
            'mx-auto mb-6 max-w-sm leading-relaxed',
            config.description,
            'text-muted-foreground'
          )}
        >
          {description}
        </p>
      )}

      {action && <div className='mt-4'>{action}</div>}
    </div>
  );
}
